import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Confetti from "../Confetti";
import { sfx } from "../../services/soundfx";
import { speak } from "../../services/phonicsAudio";

export default function CrystalAward({ crystal, stars, onContinue }) {
  useEffect(() => {
    sfx.fanfare();
    const t = setTimeout(() => speak(`Amazing! You earned the ${crystal.name}!`), 600);
    return () => clearTimeout(t);
  }, []); // eslint-disable-line

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center p-4 no-select" style={{ background: "#0F172AE6", backdropFilter: "blur(8px)" }} data-testid="crystal-award">
      <Confetti show count={90} />
      <motion.div
        initial={{ scale: 0.7, opacity: 0, y: 30 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 220, damping: 16 }}
        className="w-full max-w-md rounded-[2rem] bg-white border-[6px] shadow-2xl p-7 text-center"
        style={{ borderColor: crystal.color }}
      >
        <div className="flex items-center justify-center gap-1 mb-3">
          {[1, 2, 3].map((n) => (
            <span key={n} className="text-3xl" style={{ filter: n <= stars ? "none" : "grayscale(1) opacity(0.4)" }}>⭐</span>
          ))}
        </div>

        <p className="font-display font-bold text-slate-400 mb-2 text-sm uppercase tracking-wide">Chapter 1 Complete!</p>

        <motion.div
          animate={{ y: [0, -14, 0], rotate: [-6, 6, -6], scale: [1, 1.08, 1] }}
          transition={{ repeat: Infinity, duration: 2.6 }}
          className="text-[6.5rem] leading-none mb-1 drop-shadow-[0_0_25px_rgba(56,189,248,0.8)]"
        >
          {crystal.emoji}
        </motion.div>

        <h2 className="font-display text-3xl font-black mb-1" style={{ color: crystal.color }} data-testid="crystal-name">
          {crystal.name}
        </h2>
        <p className="font-bold text-slate-500 mb-6">You collected your very first Sound Crystal! ✨</p>

        <button
          data-testid="crystal-continue-btn"
          onClick={() => { sfx.tap(); onContinue(); }}
          className="pop-btn inline-flex items-center justify-center gap-2 rounded-full bg-indigo-500 text-white font-display text-lg font-black px-8 py-4 border-4 border-white shadow-[0_6px_0_#3730A3] active:shadow-none"
        >
          What happens next? <ArrowRight strokeWidth={3} />
        </button>
      </motion.div>
    </div>
  );
}
